import React from "react";
import { createRoot } from "react-dom/client";
import Modal from "react-modal";

import App from "./App";

if (
  window.location.protocol === "http:" &&
  window.location.hostname !== "localhost" &&
  window.location.hostname !== "127.0.0.1"
) {
  window.location.href = window.location.href.replace("http:", "https:");
}

function initializeEskimiPixel() {
  if (window.esk) {
    return;
  }

  const esk = function (...args) {
    if (esk.callMethod) {
      esk.callMethod.apply(esk, args);
    } else {
      esk.queue.push(args);
    }
  };

  esk.push = esk;
  esk.loaded = true;
  esk.queue = [];

  window.esk = esk;
  window.___esk = esk;

  const script = document.createElement("script");

  script.async = true;
  script.src = "https://dsp-media.eskimi.com/assets/js/e/gtr.min.js?_=0.0.0.6";

  const firstScript = document.getElementsByTagName("script")[0];

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    document.head.appendChild(script);
  }

  window.esk("init", "21103");
  window.esk("aid", "952022");
}

initializeEskimiPixel();

Modal.setAppElement("#root");

const container = document.getElementById("root");

if (!container) {
  throw new Error("Root elementi bulunamadı.");
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
